var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncidents(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75976 6.46791C5.19173 2.15597 6.40771 0 8.33333 0C10.259 0 11.4749 2.15597 13.9069 6.46791L14.21 7.00522C16.2309 10.5884 17.2414 12.38 16.3281 13.69C15.4149 15 13.1554 15 8.63638 15H8.03028C3.5113 15 1.25181 15 0.338548 13.69C-0.574715 12.38 0.43576 10.5884 2.45671 7.00523L2.75976 6.46791ZM8.33333 3.54167C8.67851 3.54167 8.95833 3.82149 8.95833 4.16667V8.33333C8.95833 8.67851 8.67851 8.95833 8.33333 8.95833C7.98816 8.95833 7.70833 8.67851 7.70833 8.33333V4.16667C7.70833 3.82149 7.98816 3.54167 8.33333 3.54167ZM8.33333 11.6667C8.79357 11.6667 9.16667 11.2936 9.16667 10.8333C9.16667 10.3731 8.79357 10 8.33333 10C7.8731 10 7.5 10.3731 7.5 10.8333C7.5 11.2936 7.8731 11.6667 8.33333 11.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidents);
export default __webpack_public_path__ + "static/media/incidents.7fe3b3091d06f733ba05d22cc0e63485.svg";
export { ForwardRef as ReactComponent };